import type { DefaultDtoType, Field } from "../Field";
import { initField } from "../Field";
import type { InferOutput } from "valibot";
import { object } from "valibot";
import { label } from "../../utils/validation/base";
import { useTranslation } from "../../state/i18n";
import { TextInput } from "../../components/inputs/TextInput";
import { useFormServices } from "../../services/formServices";
import PropertySection from "../PropertySection";
import { LabelFieldPreview } from "../FieldPreviewComponents";
import { keyFromSelector } from "i18next";

const Schema = object({
  label_text: label(),
});

export type LabelFieldProperties = InferOutput<typeof Schema>;

const LabelField: Field<LabelFieldProperties, DefaultDtoType> = {
  type: "label",
  category: "layout",
  widget: "com.moreapps:label:1",
  schema: Schema,
  hasData: false,
  defaultProperties: () => ({}),
  icon: "bookmark",
  titleKey: keyFromSelector(($) => $.LABEL_FIELD_LABEL),
  descriptionKey: keyFromSelector(($) => $.LABEL_FIELD_DESCRIPTION),
  propertyKeys: {
    label_text: keyFromSelector(($) => $.FIELD_PROPERTY_LABEL_VALUE),
  },
  PreviewContent: (props) => <LabelFieldPreview value={props.properties.label_text} />,
  EditItem: (props) => {
    const { t } = useTranslation();
    const { fieldService } = useFormServices();

    return (
      <PropertySection>
        <TextInput
          label={t(props.propertyKeys.label_text)}
          value={props.data.properties.label_text}
          onBlur={(e) => fieldService.setLabelProperty(props.uid, e.target.value)}
          errorMessage={props.getError("label_text")}
          required
        />
      </PropertySection>
    );
  },
};

export default initField(LabelField);
